import { render, staticRenderFns } from "./ComplaintLog.vue?vue&type=template&id=68923488&scoped=true&"
import script from "./ComplaintLog.vue?vue&type=script&lang=js&"
export * from "./ComplaintLog.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintLog.vue?vue&type=style&index=0&id=68923488&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68923488",
  null
  
)

export default component.exports